(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hsd-bulk-orders"]) return;
  try {
    

document.addEventListener('click', function(event) {
  const link = event.target.closest('[data-hsd-product]');
  if (!link) return;
  const root = link.closest('[data-hsd-bulk]');
  const select = root && root.querySelector('#HsdBulkProduct');
  if (select) {
    select.value = link.dataset.hsdProduct;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }
});
function hsdFocusResult(root) {
  const result = root.querySelector('[data-hsd-result]');
  if (result) {
    result.focus({ preventScroll: true });
    result.scrollIntoView({ block: 'center' });
  }
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() { hsdFocusResult(document); }, { once: true });
} else {
  hsdFocusResult(document);
}
document.addEventListener('shopify:section:load', function(event) { hsdFocusResult(event.target); });


  } catch(e) { console.error(e); }
})();
})();
